export const TAX_RATE = 21;